<template minapp='mpx' xlang='wxml'>
  <view
    class="es-container custom-class"
    wx:style="{{ {flexDirection: direction} }}"
    bindtap="containerTap"
  >
    <slot name="bg-icon"></slot>
    <view class="es-header" wx:if="{{slot.header}}">
      <es-navbar
        custom-class="custom-navbar"
        custom-title="custom-title"
        class="es-header__navbar"
        wx:if="{{useDefaultNavbar}}"
        wx:style="{{navbarStyle}}"
        on-click-left="{{navbarClickLeft}}"
        left-arrow="{{leftArrow}}"
        left="{{left}}"
        use-web-back="{{navbarUseWebBack}}"
      >
        {{ navbarTitle }}
        <view slot="right" wx:if="{{navbarUseRight}}">
          <slot name="narbar-right" />
        </view>
      </es-navbar>
      <slot name="header"></slot>
    </view>
    <view class="es-main custom-main" wx:style="{{esMainStyle}}">
      <scroll-view
        class="es-main-scroller"
        scroll-x="{{scrollX}}"
        scroll-y="{{scrollY}}"
        scroll-top="{{scrollTop}}"
        scroll-left="{{scrollLeft}}"
        scroll-into-view="{{scrollIntoView}}"
        bindscroll="scrollHandle"
        bindscrolltoupper="scrollToTopHandle"
        bindscrolltolower="scrollToBottomHandle"
        scroll-with-animation="{{scrollWithAnimation}}"
      >
      <es-blank-page
          wx:if="{{useBlankPage}}"
          type="{{blankPageType}}"
          loadingContext="{{loadingContext}}"
          blankButtonContext="{{blankButtonContext}}"
          blankContextTitle="{{blankContextTitle}}"
          blankContextSubTitle="{{blankContextSubTitle}}"
          loadingImageUrl="{{loadingImageUrl}}"
          blankImageUrl="{{blankImageUrl}}"
          hasButton="{{hasBlankButton}}"
          hasSubTitle="{{hasBlankSubTitle}}"
          hasTitle="{{hasBlankTitle}}"
          setBlankContext="{{setBlankContext}}"
          bind:click-button="clickButton"
          blank-title-style="{{blankTitleStyle}}"
          blank-subtitle-style="{{blankSubtitleStyle}}"
          categoryLoadingTitle="{{categoryLoadingTitle}}"
          categoryLoadingDesc="{{categoryLoadingDesc}}"
        >
          <view slot="blankContextTitle">
            <slot name="blankContext" />
          </view>
        </es-blank-page>
        <slot wx:else></slot>
      </scroll-view>
    </view>
    <view class="es-footer custom-footer" wx:if="{{slot.footer}}">
      <slot name="footer"></slot>
    </view>
  </view>
</template>

<script>
  import { createComponent, mpx } from '@didi/es-mpx-creator'
  let mainHeight = 580
  createComponent({
    externalClasses: [
      'custom-class',
      'custom-main',
      'custom-navbar',
      'custom-title',
      'custom-footer'
    ],
    props: {
      layout: {
        type: Array,
        value: ['header']
      },
      esMainStyle: Object,
      useDefaultNavbar: {
        type: Boolean,
        value: true
      },
      direction: {
        type: String,
        value: 'column'
      },
      navbarUseRight: Boolean,
      leftArrow: Boolean,
      left: String,
      navbarStyle: null,
      navbarClickLeft: null,
      navbarTitle: String,
      navbarUseWebBack: {
        type: Boolean,
        value: false
      },
      scrollTop: Number,
      scrollLeft: Number,
      scrollIntoView: String,
      scrollWithAnimation: Boolean,

      setBlankContext: {
        type: Boolean,
        value: false
      },
      blankPageType: {
        type: String,
        value: 'show-page'
      },
      useBlankPage: {
        type: Boolean,
        value: false
      },
      loadingContext: {
        type: String,
        value: '数据加载中...'
      },
      blankButtonContext: {
        type: String,
        value: '重试'
      },
      blankContextTitle: {
        type: String,
        value: '加载失败'
      },
      blankContextSubTitle: {
        type: String,
        value: '请检查网络设置或稍后重试'
      },
      loadingImageUrl: {
        type: String,
        value:
          'https://pt-starimg.didistatic.com/static/starimg/img/VY4SkVNwXT1644496067250.gif'
      },
      blankImageUrl: {
        type: String,
        value:
          'https://pt-starimg.didistatic.com/static/starimg/img/YMkvZdbImg1644496134866.png'
      },
      hasBlankButton: {
        type: Boolean,
        value: true
      },
      hasBlankSubTitle: {
        type: Boolean,
        value: true
      },
      hasBlankTitle: {
        type: Boolean,
        value: true
      },
      blankTitleStyle: null,
      blankSubtitleStyle: null,
      // 是否强制重绘
      isForceUpdate: {
        type: Boolean,
        value: true
      },
      // 品类加载标题
      categoryLoadingTitle: {
        type: String,
        value: ''
      },
      // 品类加载描述
      categoryLoadingDesc: {
        type: String,
        value: ''
      }
    },

    computed: {
      slot() {
        return this.layout.reduce((slot, key) => ((slot[key] = true), slot), {})
      },
      scrollX() {
        return this.direction === 'row'
      },
      scrollY() {
        return this.direction === 'column'
      }
    },
    pageLifetimes: {
      show: function () {
        if (this.isForceUpdate) {
          // 由于部分情况（比如其他页面弹起键盘后）,scroll-view宽高会变为0，导致页面布局错乱，重绘页面
          this.$forceUpdate()
        }
      }
    },
    mounted() {
      setTimeout(() => {
        this.getElement('.custom-main', (rect) => {
          const { height } = rect || {}
          mainHeight = height
        })
      }, 500)
    },

    methods: {
      //点击事件
      containerTap() {
        this.$trigger('container-tap')
      },
      // 获取当前的元素节点
      getElement(ele, cb) {
        const query = mpx.createSelectorQuery().in(this)
        query.select(ele).boundingClientRect(cb).exec()
      },
      /**
       * @description: 滚动事件
       */
      scrollHandle(e) {
        this.triggerEvent('scrolling', e)
      },

      /**
       * @description: 滚动到顶部事件
       */
      scrollToTopHandle(e) {
        this.triggerEvent('scrolltotop', e)
      },

      /**
       * @description: 滚动到底部事件
       */
      scrollToBottomHandle(e) {
        this.triggerEvent('scrolltobottom', e)
      },

      /**
       * @description: 空白页按钮点击事件
       */
      clickButton() {
        this.$trigger('blank-retry')
      },
      getCustomMainHeight() {
        return mainHeight
      }
    }
  })
</script>

<style lang='stylus' src='./style.styl'></style>

<script name='json'>
  module.exports = {
    component: true,
    usingComponents: {
      'es-navbar': '../navbar/index',
      'es-blank-page': '@/es-mpx-ui/lib/blank-page/index'
    }
  }
</script>
